<template>
	<div class="aboutBox">
		<div class="custom-box posi-r" ref="customBox">
			<styleysOne :classId='"style-one"'></styleysOne>
			<styleTwo :classId='"style-two"'></styleTwo>
			<div class="about_box posi-r overflow" v-loading="loadingOne">
				<div class="about_title overflow">
					<p class="text-c font-size-1">About Us </p>
					<p class="text-c font-size-2">{{contactUs.title}}</p>
					<p class="text-c font-size-3">{{contactUs.descContent}}</p>
				</div>
				<div class="about_anner overflow posi-r">
					<styleysOne :classId='"style-three"'></styleysOne>
					<div class="anner-box pull-l width-left">
						<div class="anner-b">
							<div class="img-boxs overflow">
								<v-lazy-image :src="$axios.defaults.baseURL+contactUs.coverPic"
									:src-placeholder="require('@/assets/img/loading1.png')" class="annerImg"/>
							</div>
						</div>
					</div>
					<div class="anner-box pull-r overflow width-right">
						<div class="wh-100">
							<div class="title-r overflow" v-html="contactUs.titleIntro">
								<!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;九丰互联（北京）科技有限公司，10余年深耕企业礼赠服务行业，为超过60家企业用户提供专业、丰富、便捷的企业福利礼赠和营销活动策划解决方案，公司4大服务板块涵盖礼赠品设计开发与制作、品牌商品供应、积分平台运营、数字营销策划与执行，是您真正专业的企业福利管家。 -->
							</div>
							<!-- <div class="button_about text-c">
								联系我们
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="custom-box posi-r overflow" v-loading="loadingTwo" v-if="butler.length>0">
			<div class="custom-list pull-r">
				<div class="custom_title overflow ">
					<p class="text-l font-size-1">Custom Case</p>
					<p class="text-l font-size-2">您真正的企业福利管家</p>
				</div>
				<div class="list-box posi-r">
					<div class="ul-list-box"></div>
					<div class="tr-box pull-r">
						<swiper :options="swiperOption">
							<swiper-slide v-for="(item,index) in butler" :key="index">
								<div class="liBox posi-r pull-l">
									<div class="bo">
										<div class="img-box-top">
											<v-lazy-image :src="$axios.defaults.baseURL+JSON.parse(item.coverPic).path"
												:src-placeholder="require('@/assets/img/loading1.png')" class="book"/>
										</div>
									</div>
									<div class="bottom-box">
										<p class="year text-l">{{item.title}} </p>
										<p class="name ellipsis text-l">{{item.descContent}}</p>
									</div>
								</div>
							</swiper-slide>
						</swiper>
					</div>
				</div>
			</div>
		</div>
		<div class="custom-box posi-r overflow" v-loading="loadingThree" v-if="service.length>0">
			<styleysOne :classId='"style-five"'></styleysOne>
			<div class="custom-list pull-l">
				<div class="custom_title overflow ">
					<p class="text-r font-size-1">McCartoon Mall</p>
					<p class="text-r font-size-2">麦卡通企业服务平台</p>
				</div>
				<div class="list-box posi-r">
					<div class="ul-list-box-Two"></div>
					<div class="tr-box-two pull-r" ref="trBoxTwo">
						<swiper :options="swiperOptions">
							<swiper-slide v-for="(item,index) in service" :key="index">
								<div class="liBox posi-r pull-l">
									<div class="bo">
										<div class="img-box-top">
											<v-lazy-image :src="$axios.defaults.baseURL+JSON.parse(item.coverPic).path"
												:src-placeholder="require('@/assets/img/loading1.png')" class="book"/>
										</div>
									</div>
									<div class="bottom-box">
										<p class="year text-l">{{item.title}} </p>
										<p class="name ellipsis text-l">{{item.descContent}}</p>
									</div>
								</div>
							</swiper-slide>
						</swiper>
					</div>
				</div>
			</div>
		</div>
		<div class="custom-box posi-r overflow">
			<styleysOne :classId='"style-six"'></styleysOne>
			<styleysOne :classId='"style-senve"'></styleysOne>
			<div class="three-box overflow">
				<div class="img-box posi-r">
					<div class="img-b">
						<!-- <img src="@/assets/img/img1.png" alt="" class=""> -->
						<v-lazy-image :src="platform.coverPic1?($axios.defaults.baseURL+platform.coverPic1):''"
							:src-placeholder="require('@/assets/img/loading1.png')" class=""/>
					</div>
					<div class="cum-name text-c">{{platform.name1}}</div>
				</div>
				<div class="img-box posi-r margin-lr">
					<div class="img-b">
						<v-lazy-image :src="platform.coverPic2?($axios.defaults.baseURL+platform.coverPic2):''"
							:src-placeholder="require('@/assets/img/loading1.png')" class=""/>
					</div>
					<div class="cum-name text-c">{{platform.name2}}</div>
				</div>
				<div class="img-box posi-r">
					<div class="img-b">
						<v-lazy-image :src="platform.coverPic3?($axios.defaults.baseURL+platform.coverPic3):''"
							:src-placeholder="require('@/assets/img/loading1.png')" class=""/>
					</div>
					<div class="cum-name text-c">{{platform.name3}}</div>
				</div>
			</div>
			<div class="cum-title" v-html="platform.title">
				<!-- &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司在立足传统礼品行业基础上，积极整合资源打造线上平台，专注于企业采购电商化领域，九丰互联拥有自己的电商平台。为企业团购、员工福利、积分营销等提供专业定制、平台开发、供应链服务、线上服务等一体化解决方案，
				不断创新服务模式，打造企业核心竞争力。 -->
			</div>
		</div>
	</div>

</template>
<script>
	import styleysOne from '../../components/style.vue'
	import styleTwo from '../../components/styleTwo.vue'
	// 引入Swiper和SwiperSlide组件
	import 'swiper/css/swiper.css'
	import {
		Swiper,
		SwiperSlide,
		directive
	} from 'vue-awesome-swiper'
	import VLazyImage from "v-lazy-image/v2";
	// :slides-per-view: 这个属性设置了每个滑块（slide）的可见数量。在这里，设置为 1 表示每次只显示一个滑块。
	// :space-between：这个属性设置了滑块之间的间距。在这里，设置为 0 表示滑块之间没有间距。
	export default {
		name: '',
		components: {
			styleysOne,
			styleTwo,
			Swiper,
			SwiperSlide,
			VLazyImage
		},
		directives: {
			swiper: directive
		},
		data() {
			return {
				butler: [],
				loadingTwo: false,
				loadingThree: false,
				service: [],
				contactUs: {
					coverPic: "",
					titleIntro: "",
					title: "",
					descContent: ""
				},
				platform: {
					name1: "",
					name2: "",
					name3: "",
					"coverPic1": "",
					"coverPic2": "",
					"coverPic3": "",
					"title": "",
				},
				loadingOne: false,
				slides: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
				swiperOption: {
					slidesPerView: "auto",
					// slidesPerView: 'auto', //设置slider容器能够同时显示的slides数量(carousel模式)。
					autoplay: false, //设置为true启动自动切换，并使用默认的切换设置。
					direction: 'horizontal', //设置滑动方向
					centeredSlides: false, //设定为true时，active slide会居中，而不是默认状态下的居左。
					observeParents: true, //这个是启动动态检查器(OB/观众/观看者)，当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper。
					grabCursor: true, //置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状。（根据浏览器形状有所不同）
					autoplayDisableOnInteraction: false, //是否禁止autoplay。默认为true：停止。
					mousewheel: { //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，或true使用默认值。 默认1 
						sensitivity: 1,
					},
					autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					preventClicks: false, //默认true
					preventClicksPropagation: true, //阻止click冒泡。拖动Swiper时阻止click事件
					slideToClickedSlide: true, //设置为true则点击slide会过渡到这个slide。
				},
				swiperOptions: {
					initialSlide: 9,
					slidesPerView: "auto",
					// slidesPerView: 'auto', //设置slider容器能够同时显示的slides数量(carousel模式)。
					autoplay: false, //设置为true启动自动切换，并使用默认的切换设置。
					direction: 'horizontal', //设置滑动方向
					centeredSlides: false, //设定为true时，active slide会居中，而不是默认状态下的居左。
					observeParents: true, //这个是启动动态检查器(OB/观众/观看者)，当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper。
					grabCursor: true, //置为true时，鼠标覆盖Swiper时指针会变成手掌形状，拖动时指针会变成抓手形状。（根据浏览器形状有所不同）
					autoplayDisableOnInteraction: false, //是否禁止autoplay。默认为true：停止。
					mousewheel: { //开启鼠标滚轮控制Swiper切换。可设置鼠标选项，或true使用默认值。 默认1 
						sensitivity: 1,
					},
					autoHeight: true, //自动高度。设置为true时，wrapper和container会随着当前slide的高度而发生变化。
					observer: true, //修改swiper自己或子元素时，自动初始化swiper
					preventClicks: false, //默认true
					preventClicksPropagation: true, //阻止click冒泡。拖动Swiper时阻止click事件
					slideToClickedSlide: true, //设置为true则点击slide会过渡到这个slide。
				},


			}
		},
		computed: {

		},
		mounted() {},
		created() {
			this.getIndex();
		},
		methods: {
			getIndex() {
				this.loadingOne = true;
				this.loadingThree = true;
				this.loadingTwo = true;
				this.loadingFour = true;
				this.$axios.get('/index/getIndexContent?type=4')
					.then((res) => {
						this.loadingFour = false;
						console.log(res)
						if (res.status === 200 && res.data.code === 200) {
							if(res.data.data.length>0){
								this.platform = {
									name1: JSON.parse(res.data.data[0].coverPic).coverPic1.name,
									name2: JSON.parse(res.data.data[0].coverPic).coverPic2.name,
									name3: JSON.parse(res.data.data[0].coverPic).coverPic3.name,
									"coverPic1": JSON.parse(res.data.data[0].coverPic).coverPic1.path,
									"coverPic2": JSON.parse(res.data.data[0].coverPic).coverPic2.path,
									"coverPic3": JSON.parse(res.data.data[0].coverPic).coverPic3.path,
									"title": res.data.data[0].title,
								}
							}
							
							return;
						}
						this.$message.error(res.data.msg || '获取运营信息失败，请重新请求!');
					})
					.catch((error) => {
						this.loadingFour = false;
						this.$message.error('获取运营信息异常，请重新请求!');
					});
				this.$axios.get('/index/getIndexContent?type=3')
					.then((res) => {
						this.loadingThree = false;
						console.log(res)
						if (res.status === 200 && res.data.code === 200) {
							this.service = []
							if(res.data.data.length>0){
							this.service = res.data.data}
							return;
						}
						this.$message.error(res.data.msg || '获取服务平台信息失败，请重新请求!');
					})
					.catch((error) => {
						this.loadingThree = false;
						this.$message.error('获取服务平台信息异常，请重新请求!');
					});
				this.$axios.get('/index/getIndexContent?type=2')
					.then((res) => {
						this.loadingTwo = false;
						console.log(res)
						if (res.status === 200 && res.data.code === 200) {
							this.butler = []
							if(res.data.data.length>0){
							this.butler = res.data.data}
							return;
						}
						this.$message.error(res.data.msg || '获取福利管家信息失败，请重新请求!');
					})
					.catch((error) => {
						this.loadingTwo = false;
						this.$message.error('获取福利管家信息异常，请重新请求!');
					});

				this.$axios.get('/index/getIndexContent?type=1')
					.then((res) => {
						this.loadingOne = false;
						console.log(res)
						if (res.status === 200 && res.data.code === 200) {
							if(res.data.data.length>0){
								this.contactUs = {
									coverPic:JSON.parse(res.data.data[0].coverPic).path,
									title: res.data.data[0].title,
									titleIntro: res.data.data[0].titleIntro,
									descContent: res.data.data[0].descContent,
								}
							}
							return;
						}
						this.$message.error(res.data.msg || '获取联系我们失败，请重新请求!');
					})
					.catch((error) => {
						console.log("error",error)
						this.loadingOne = false;
						this.$message.error('获取联系我们异常，请重新请求!');
					});
			}
		},
	};
</script>

<style scoped>
	.custom_title {
		margin-bottom: 60rem
	}

	.margin-lr {
		margin: 0 20rem;
	}

	.three-box {
		width: 56%;
		margin: 180rem auto 0;
		display: flex;

	}

	.cum-title {
		margin: 30rem auto 150rem;
		width: 56%;
		font-size: 18rem;
		line-height: 36rem;
	}

	.img-box .cum-name {
		font-size: 28rem;
		font-weight: bold;
		margin: 35rem 0 50rem;
	}

	.img-box {
		width: 100%;
		height: 480rem;
		font-size: 15rem;
		overflow: hidden;
		padding-right: 15rem;
		padding-bottom: 15rem;
	}

	.img-box .img-b {
		width: 100%;
		height: 300rem;
		overflow: hidden;
		margin-left: 15rem;
		box-shadow: -15rem 15rem 0 #F3F6FC;
		border-radius: 50rem;
	}

	.img-b img {
		width: 100%;
		display: inline-block;
		vertical-align: middle;
		height: 100%;
		object-fit: cover
	}
	.swiper-slide {
		width: 220rem !important;
		background: none !important;
		display: initial !important;
		margin-right: 20rem !important;
	}

	.swiper-slide:last-child {
		margin-right: 0 !important;
	}

	.swiper {
		z-index: 15;
		position: absolute;
	}

	.list-box .tr-box {
		width: 98%;
		height: 100%;
		position: absolute;
		bottom: 0;
		right: 0;
	}

	.list-box .tr-box-two {
		width: 98%;
		height: 100%;
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.list-box .ul-list-box {
		height: 164rem;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background: #E7E8EF;
		border-top-left-radius: 50rem;
		border-bottom-left-radius: 50rem;
	}

	.list-box {
		width: 100%;
		cursor: pointer;
		padding-bottom: 164rem;
		height: 166rem;
		position: relative;



	}










	.list-box .ul-list-box-Two {
		height: 164rem;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		background: #E7E8EF;
		border-top-right-radius: 50rem !important;
		border-bottom-right-radius: 50rem !important;
	}

	.list-box .bo {
		position: absolute;
		bottom: 0;
		left: 12rem;
		right: 12rem;
		top: 0;
		z-index: 10;
	}

	.list-box .liBox {
		height: 300rem;
		width: 220rem;
		margin-right: 20rem;
		position: relative;
		border-bottom-right-radius: 20rem;
		border-bottom-left-radius: 20rem;
		z-index: 6;



	}

	.list-box .bottom-box {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 134rem;
		background: #fff;
		border-bottom-right-radius: 20rem;
		border-bottom-left-radius: 20rem;
		box-shadow: 0rem 6rem 12rem rgba(0, 0, 0, 0.03),

	}

	.list-box .liBox:last-child {
		margin-right: 0 !important;
	}

	.list-box .book {
		width: 100%;
		/* height: 234rem; */
		z-index: 30;
		position: absolute;
		display: inline-block;
		vertical-align: middle;
		/* 设置绝对定位 */
		top: 50%;
		/* 图标顶部位置 */
		left: 50%;
		/* 图标左侧位置 */
		transform: translate(-50%, -50%);
		/* 调整图标使其居中 */
		height: 100%;
		object-fit: cover;
	}

	.img-box-top {
		width: 100%;
		height: 234rem;
		z-index: 15;
		clip-path: polygon(0% -4%, 0% 100%, 0 100%, 330% 100%);
		background: #f5f5f5;
		position: relative;
		border-radius: 20rem;
		/* 添加圆角 */
		overflow: hidden;
		&::after {
			/*   content: "";
		        position: absolute;
		        top: 0;
		        left: 0;
		        right: 0;
		        bottom: 0;
		        border-radius: 20rem;
		        background: orange;
		        transform: skewX(-15deg); */
		}
		&::before {
			transform: skewX(-28deg);
			content: "";
			border-radius: 20rem;
			position: absolute;
			top: 60px;
			right: 16px;
			width: 100px;
			height: 100px;
			background: #f5f5f5;
		}

	}




	.swiper {
		width: 100%;
		height: 100%;
	}

	.swiper-slide {
		text-align: center;
		font-size: 18rem;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.year {
		color: #3662C7;
		font-size: 14rem;
		line-height: 20rem;
		margin-top: 80rem;
		margin-left: 12rem;
		font-weight: 500;
	}

	.name {
		font-size: 14rem;
		line-height: 20rem;
		margin-left: 12rem
	}


	.custom-list {
		width: 90%;
		margin-top: 140rem;
	}

	.sro-box {}

	.liboxlist {
		margin-left: 350rem;
	}


	.title-r,
	.wh-100,
	.custom-box {
		width: 100%;
		height: 100%;
	}

	.button_about {
		width: 150rem;
		height: 45rem;
		line-height: 45rem;
		position: absolute;
		bottom: 0;
		right: 30rem;
		color: #fff;
		font-size: 16rem;
		background: #3662C7;
		border-radius: 50rem;
	}

	.about_anner {
		padding-top: 50rem
	}

	.wh-100 {
		position: relative;
		padding-top: 60rem;
		height: calc(100% - 105rem) !important;
		padding-bottom: 60rem;
	}
</style>